import { render } from "./ActionCard.vue?vue&type=template&id=b013ffe4&scoped=true"
import script from "./ActionCard.vue?vue&type=script&lang=js"
export * from "./ActionCard.vue?vue&type=script&lang=js"

import "./ActionCard.vue?vue&type=style&index=0&id=b013ffe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b013ffe4"]])

export default __exports__